import{Paper as p}from"@mantine/core";import{jsx as o}from"@emotion/react/jsx-runtime";function e(r){return o(p,{...r})}var a=e;export{a as Paper};
